import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SnackbarStatus } from '@Utilities/SnackbarConfig'

type openSnackbarArgs = { status?: SnackbarStatus; text: string }
type SnackbarStateArgs = { url?: string; isEmbed: boolean }

const initialState: SnackbarStateArgs = {
	url: undefined,
	isEmbed: false,
}
const UtilsSlice = createSlice({
	name: 'utils',
	initialState,
	reducers: {
		setCurrentURL: (state: SnackbarStateArgs, action: PayloadAction<string>) => {
			state.url = action.payload
		},
		resetURL: (state: SnackbarStateArgs) => {
			state.url = undefined
		},
		setEmbed: (state: SnackbarStateArgs, action: PayloadAction<boolean>) => {
			state.isEmbed = action.payload
		},
	},
})

export const { resetURL, setCurrentURL, setEmbed } = UtilsSlice.actions
export default UtilsSlice
